// @ts-ignore
import type { StringMap } from 'quill';

import {
  toolbarOptions,
  ICON,
  MENTIONS_EMPTY_AVATAR_URL,
  MENTIONS_EMPTY_AVATAR_PLACEHOLDER_CLASS,
  MENTIONS_AVATAR_CLASS,
  MENTIONS_AVATAR_SIZE,
} from './constants';
import { src, srcSet } from '@/components/utils/responsive';

const WAR_ROOM_PROFILE_PATH = '/war-room/profile';
export const setCustomIcons = (Quill: any) => {
  const icons = Quill.import('ui/icons') as StringMap;
  [
    toolbarOptions.BOLD,
    toolbarOptions.ITALIC,
    toolbarOptions.STRIKE,
    toolbarOptions.LIST,
    toolbarOptions.IMAGE,
  ].forEach(iconName => {
    icons[iconName] = ICON[iconName as keyof typeof ICON];
  });
};
export const getAvatar = (avatarUrl: string, username: string) => {
  const fragment = document.createDocumentFragment();

  if (avatarUrl.includes(MENTIONS_EMPTY_AVATAR_URL)) {
    const initials = username.slice(0, 2);
    const span = document.createElement('span');
    span.className = `${MENTIONS_EMPTY_AVATAR_PLACEHOLDER_CLASS} ${MENTIONS_AVATAR_CLASS}`;
    span.textContent = initials;
    fragment.appendChild(span);
    fragment.appendChild(document.createTextNode(` ${username}`));
  } else {
    const img = document.createElement('img');
    img.className = `${MENTIONS_AVATAR_CLASS} lazyload`;
    img.setAttribute('data-sizes', 'auto');
    img.setAttribute('data-src', src(avatarUrl, MENTIONS_AVATAR_SIZE, MENTIONS_AVATAR_SIZE));
    img.setAttribute('data-srcset', srcSet(avatarUrl, MENTIONS_AVATAR_SIZE, MENTIONS_AVATAR_SIZE));
    fragment.appendChild(img);
    fragment.appendChild(document.createTextNode(` ${username}`));
  }

  return fragment;
};

export const getWarRoomProfilePath = (username: string) => `${WAR_ROOM_PROFILE_PATH}/${username}`;
